/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  ErrorResponse,
  OrderFilter,
  OrderTableViewStateDTO,
  RequestFilter,
  RequestTableViewStateDTO,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class TableViewStateApi<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * @description Answers with 204 as well when nothing was stored for that variant.
   *
   * @tags table-view-state-api
   * @name DeleteOrderState
   * @summary Clear the stored view state of one order overview variant
   * @request DELETE:/api/table-view-states/orders/{view}
   * @secure
   */
  deleteOrderState = (view: OrderFilter, params: RequestParams = {}) =>
    this.request<void, ErrorResponse>({
      path: `/api/table-view-states/orders/${view}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * @description Answers with 204 as well when nothing was stored for that variant.
   *
   * @tags table-view-state-api
   * @name DeleteRequestState
   * @summary Clear the stored view state of one request overview variant
   * @request DELETE:/api/table-view-states/requests/{view}
   * @secure
   */
  deleteRequestState = (view: RequestFilter, params: RequestParams = {}) =>
    this.request<void, ErrorResponse>({
      path: `/api/table-view-states/requests/${view}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * @description Answers with 204 and no body when nothing is stored for that variant. The server computes no defaults — the client applies its own.
   *
   * @tags table-view-state-api
   * @name GetOrderState
   * @summary Read the stored view state of one order overview variant
   * @request GET:/api/table-view-states/orders/{view}
   * @secure
   */
  getOrderState = (view: OrderFilter, params: RequestParams = {}) =>
    this.request<OrderTableViewStateDTO, ErrorResponse>({
      path: `/api/table-view-states/orders/${view}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * @description Answers with 204 and no body when nothing is stored for that variant. The server computes no defaults — the client applies its own.
   *
   * @tags table-view-state-api
   * @name GetRequestState
   * @summary Read the stored view state of one request overview variant
   * @request GET:/api/table-view-states/requests/{view}
   * @secure
   */
  getRequestState = (view: RequestFilter, params: RequestParams = {}) =>
    this.request<RequestTableViewStateDTO, ErrorResponse>({
      path: `/api/table-view-states/requests/${view}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * @description Replaces the state stored before. The payload is stored as sent: a missing field means no restriction, an empty list means nothing selected.
   *
   * @tags table-view-state-api
   * @name PutOrderState
   * @summary Store the view state of one order overview variant
   * @request PUT:/api/table-view-states/orders/{view}
   * @secure
   */
  putOrderState = (
    view: OrderFilter,
    data: OrderTableViewStateDTO,
    params: RequestParams = {},
  ) =>
    this.request<void, ErrorResponse>({
      path: `/api/table-view-states/orders/${view}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description Replaces the state stored before. The payload is stored as sent: a missing field means no restriction, an empty list means nothing selected. The company filter is kept for the Innendienst only and silently dropped otherwise.
   *
   * @tags table-view-state-api
   * @name PutRequestState
   * @summary Store the view state of one request overview variant
   * @request PUT:/api/table-view-states/requests/{view}
   * @secure
   */
  putRequestState = (
    view: RequestFilter,
    data: RequestTableViewStateDTO,
    params: RequestParams = {},
  ) =>
    this.request<void, ErrorResponse>({
      path: `/api/table-view-states/requests/${view}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
}
